
export const getTableConfig = () => {
  // table 通用属性
  const common = {
    // table 有多选时设置
    isSelection: false,
    // table loading
    loading: false,
    // table 的高度
    height: null,
    // table 是否为斑马纹
    stripe: true,
    // table 的尺寸 medium / small / mini
    size: 'small',
    // table 是否开启索引
    isIndex: true,
    // table 索引 label
    indexLabel: '序号',
    // table 数据
    data: []
  }

  // table 分页
  const pagination = {
    // 是否展示分页
    isShow: true,
    // 总条数
    total: 100,
    // 每页显示条目个数
    pageSize: 20,
    // 当前页数
    currentPage: 1,
    // 每页显示个数选择器的选项设置
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'roleName',
      label: '角色名称',
      width: '140'
    },
    {
      key: 'roleStatusTxt',
      label: '角色状态',
      width: '140'
    },
    {
      key: 'authorizationNumber',
      label: '已授权人数(人)',
      width: '140'
    },
    {
      key: 'operator',
      label: '操作人',
      width: '140'
    },
    {
      key: 'updateTime',
      label: '更新时间',
      width: '140'
    },
    {
      key: 'action',
      label: '操作',
      width: '140',
      fixed: 'right',
      slot: 'action'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}

// 页面搜索和基础变量
export const getIndexConfig = () => {
  // 搜索变量
  const inputList = [
    {
      type: 'input',
      label: '角色名称',
      key: 'roleName',
      placeholder: '请输入',
      labelWidth: 100,
      inputWidth: 200,
      maxlength: 30,
      rules: {
      }
    },
    {
      type: 'select',
      label: '角色状态',
      key: 'roleStatus',
      placeholder: '请选择',
      labelWidth: 100,
      inputWidth: 200,
      options: [
        {
          label: '正常',
          value: 1
        }, {
          label: '禁用',
          value: 0
        }
      ],
      rules: {
        type: 'number'
      }
    }
  ]

  // 页面基础变量
  const page = {
    queryForm: {}, // 搜索参数
    total: 0,
    visible: false, // 弹框显示
    title: '新建员工',
    rowData: null // 单行数据
  }

  return {
    inputList,
    ...page
  }
}
